import { render } from "./TwoFactorAuthSetting.vue?vue&type=template&id=6ed33094"
import script from "./TwoFactorAuthSetting.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthSetting.vue?vue&type=script&lang=js"

import "./TwoFactorAuthSetting.vue?vue&type=style&index=0&id=6ed33094&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__